{
  "fr": {
    "imports": {
      "searchPlaceholder": "Nom...",
      "selectedCount": "aucun élément sélectionné | {count} sélectionné | {count} sélectionnés",
      "cancel": "Annuler",
      "confirm": "Sélectionner",
      "discard": {
        "question": "Annuler la sélection ?",
        "continue": "Continuer à ajouter",
        "confirm": "Annuler"
      },
      "tabWithCount": "{label} ({count})",
      "tabMatches": "{label} : aucun résultat | {label} : {count} résultat | {label} : {count} résultats",
      "contentList": {
        "leaveFolder": "Retour du dossier « {name} »",
        "openFolder": "Ouvrir le dossier « {name} »",
        "loading": "Chargement du contenu",
        "noResults": {
          "title": "Aucun résultat pour « {query} »",
          "text": "Essayez un autre terme de recherche"
        }
      },
      "loadMore": "Charger plus",
      "submitFailed": "Échec de l'importation. Veuillez réessayer.",
      "upload": {
        "addMore": "Sélectionner d'autres fichiers",
        "dropFiles": "Faites glisser et déposez les fichiers ici ou sélectionnez-les.",
        "interrupted": "Un téléversement a été annulé. Veuillez réessayer de téléverser le fichier.",
        "removeFile": "Supprimer « {name} »",
        "uploaded": "Téléchargement réussi.",
        "wrongType": "Ce type de fichier n'est pas pris en charge."
      },
      "toTeach": {
        "modalTitle": "Importer des fiches d'exercices to teach",
        "menuItem": "Importation de to teach",
        "importedBadge": "Importé de to teach",
        "link": {
          "title": "Lier le compte",
          "body": "Votre compte n'est pas encore lié à to teach. Connectez votre compte pour utiliser vos contenus to teach sur fobizz.",
          "confirm": "Accéder à to teach"
        },
        "worksheets": {
          "tabLabel": "Votre compte to teach",
          "accountLink": "Votre compte to teach",
          "searchPlaceholder": "Rechercher des fiches d'exercices to teach",
          "empty": "Aucune fiche d'exercices to teach trouvée.",
          "errorLoading": "Vos fiches d'exercices to teach n'ont pas pu être chargées.",
          "batchQueuedFlash": "Votre fiche d'exercices est importée en arrière-plan. | Votre fiche d'exercices est importée en arrière-plan. | {count} fiches d'exercices sont importées en arrière-plan."
        }
      },
      "breadcrumb": {
        "label": "Chemin du dossier",
        "more": "Afficher plus de dossiers"
      },
      "myContent": {
        "empty": {
          "title": "Votre espace de stockage est encore vide",
          "text": "Les fichiers téléchargés apparaîtront ici."
        },
        "emptyFiltered": {
          "title": "Aucun contenu correspondant",
          "text": "Modifiez les filtres ou sélectionnez « Tout afficher »."
        },
        "emptyFolder": "Ce dossier est vide.",
        "errorLoading": "Votre contenu n'a pas pu être chargé.",
        "toggleFilters": "Afficher les filtres",
        "periodLabel": "Période :",
        "noAddableContent": {
          "title": "Il n'y a rien à ajouter ici",
          "text": "Ces contenus sont déjà ajoutés ou ne peuvent pas être utilisés ici."
        }
      }
    }
  }
}
